import type { Entry } from "contentful";
import { cn } from "@/lib/utils";
import type { TypePageHeaderSkeleton } from "@/types/contentful/generated";

type Props = {
  pageHeader?: Entry<TypePageHeaderSkeleton, undefined, string>;
  category?: string;
  className?: string;
};

export default function PageHeader({ pageHeader, category, className }: Props) {
  if (category) {
    return (
      <div className={cn("px-6 pt-6 w-full max-w-site-content mx-auto", className)}>
        <h1 className="text-4xl">{category}</h1>
      </div>
    );
  }

  if (!pageHeader?.fields) return null;
  const { headline, subheadline } = pageHeader.fields;

  return (
    <div className={cn("px-6 pt-6 w-full max-w-site-content mx-auto", className)}>
      <h1 className="text-4xl">{headline}</h1>
      {subheadline && <h2 className="text-xl heading-xs">{subheadline}</h2>}
    </div>
  );
}
